// extracted by mini-css-extract-plugin
var _1 = "SearchManagePlatformButton-module__animateUploadProgressBarWidth--qXa1O";
var _2 = "SearchManagePlatformButton-module__animatedBackground--uA6iL";
var _3 = "SearchManagePlatformButton-module__buttonWrapper--i6nVm";
var _4 = "SearchManagePlatformButton-module__settingsSectionTitle--emWnp";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonWrapper", _4 as "settingsSectionTitle" }
